const DocumentsIllustration = () => (
  <svg
    viewBox="0 0 200 200"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width="160"
    height="160"
    role="presentation"
  >
    <rect
      x="46"
      y="42"
      width="118"
      height="148"
      rx="12"
      fill="#eef1fb"
      stroke="#dde3f3"
      strokeWidth="1"
    />
    <rect
      x="32"
      y="28"
      width="118"
      height="148"
      rx="12"
      fill="#fff"
      stroke="#c8d2e8"
      strokeWidth="1.5"
    />

    <rect x="46" y="48" width="34" height="18" rx="4" fill="#e9eaff" />
    <text
      x="63"
      y="61"
      fontFamily="system-ui, -apple-system, sans-serif"
      fontSize="10"
      fontWeight="700"
      fill="#3744d6"
      textAnchor="middle"
    >
      QES
    </text>

    <rect x="86" y="52" width="48" height="8" rx="2" fill="#1f2937" />

    <rect x="46" y="84" width="86" height="3" rx="1.5" fill="#e1e6f0" />
    <rect x="46" y="94" width="64" height="3" rx="1.5" fill="#e1e6f0" />
    <rect x="46" y="104" width="78" height="3" rx="1.5" fill="#e1e6f0" />

    <rect
      x="46"
      y="122"
      width="86"
      height="38"
      rx="6"
      fill="#fff"
      stroke="#7c8eb3"
      strokeWidth="1.2"
      strokeDasharray="3 3"
    />
    <path
      d="M 56 146 Q 65 136 75 146 Q 85 156 95 146 Q 105 136 116 146"
      stroke="#224bd0"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <circle
      cx="148"
      cy="34"
      r="14"
      fill="#34c47c"
      stroke="#fff"
      strokeWidth="2.5"
    />
    <path
      d="M 142 34 L 147 39 L 155 30"
      stroke="#fff"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default DocumentsIllustration;
